import { AccordionAccountholderFormVM } from 'front-office/view-models/certificate/accountholder-form';
import * as yup from 'yup';
import { DocumentRadioCertificate } from '../document-radio-certificate';

export const applicantSchema = yup.object().shape({
  // fiscalCode: yup.string().required('Campo obbligatorio'),
  withoutSurname: yup.boolean(),
  withoutName: yup.boolean(),
  surname: yup.string().when('withoutSurname', {
    is: false || undefined,
    then: yup.string().required('Campo obbligatorio'),
    otherwise: yup.string(),
  }),
  name: yup.string().when('withoutName', {
    is: false || undefined,
    then: yup.string().required('Campo obbligatorio'),
    otherwise: yup.string(),
  }),
  gender: yup.string().required('Campo obbligatorio'),
});

interface ValidationCertificationSchemaShape {
  certifiableApplicant: yup.BooleanSchema<boolean | undefined>;
  certifiableAccountholder: yup.BooleanSchema<boolean | undefined>;
  certificateInternOnly: yup.BooleanSchema<boolean | undefined>;
  applicant: yup.AnyObjectSchema; // Dipende da applicantSchema
  generality: yup.AnyObjectSchema; // Oggetto complesso definito sotto
  accountholder?: yup.AnyObjectSchema; // Oggetto complesso con custom test
}

export const validationCertificationSchema: ValidationCertificationSchemaShape = {
  certifiableApplicant: yup.boolean(),
  certifiableAccountholder: yup.boolean(),
  certificateInternOnly: yup.boolean(),
  applicant: yup.object().when('certificateInternOnly', {
    is: false,
    then: yup.object().shape({
      // fiscalCode: yup.string().required('Campo obbligatorio'),
      withoutSurname: yup.boolean(),
      withoutName: yup.boolean(),
      surname: yup.string().when('withoutSurname', {
        is: false || undefined,
        then: yup.string().required('Campo obbligatorio'),
        otherwise: yup.string(),
      }),
      name: yup.string().when('withoutName', {
        is: false || undefined,
        then: yup.string().required('Campo obbligatorio'),
        otherwise: yup.string(),
      }),
      gender: yup.string().required('Campo obbligatorio'),
    }),
    otherwise: yup.object().shape({}),
  }),
  generality: yup.object().when('certificateInternOnly', {
    is: false,
    then: yup.object().shape({
      searchApplicant: yup.boolean().required('Effettuare ricerca'),
      witness1: yup
        .string()
        .nullable()
        .when('isForeignDocument', {
          is: DocumentRadioCertificate.Witness,
          then: yup.string().required('Campo obbligatorio'),
          otherwise: yup.string().nullable().notRequired(),
        }),
      witness1IdentityCard: yup
        .string()
        .nullable()
        .when('isForeignDocument', {
          is: DocumentRadioCertificate.Witness,
          then: yup.string().required('Campo obbligatorio'),
          otherwise: yup.string().nullable().notRequired(),
        }),
      witness2: yup
        .string()
        .nullable()
        .when('isForeignDocument', {
          is: DocumentRadioCertificate.Witness,
          then: yup.string().required('Campo obbligatorio'),
          otherwise: yup.string().nullable().notRequired(),
        }),
      witness2IdentityCard: yup
        .string()
        .nullable()
        .when('isForeignDocument', {
          is: DocumentRadioCertificate.Witness,
          then: yup.string().required('Campo obbligatorio'),
          otherwise: yup.string().nullable().notRequired(),
        }),
      numberDocument: yup.string().when('isForeignDocument', {
        is: DocumentRadioCertificate.Witness,
        then: yup.string().nullable().notRequired(),
        otherwise: yup.string().required('Campo obbligatorio'),
      }),
      birthDate: yup.date().nullable().required('Campo obbligatorio').typeError('Data non valida'),
      isForeign: yup.boolean(),
      foreignStateBirth: yup
        .object()
        .shape({})
        .nullable()
        .when('isForeign', {
          is: true,
          then: yup.object().shape({}).nullable().required(),
          otherwise: yup.object().shape({}).nullable(),
        }),
      foreignMunicipality: yup
        .object()
        .shape({})
        .nullable()
        .when('isForeign', {
          is: true,
          then: yup.object().shape({}).nullable().required(),
          otherwise: yup.object().shape({}).nullable(),
        }),
      municipalityOfBirth: yup
        .object()
        .shape({})
        .nullable()
        .when('isForeign', {
          is: true,
          otherwise: yup.object().shape({}).nullable().required(),
          then: yup.object().shape({}).nullable(),
        }),
      dateReleaseDocument: yup.date().when('isForeignDocument', {
        is: DocumentRadioCertificate.Witness,
        then: yup.date().nullable().typeError('Data non valida').notRequired(),
        otherwise: yup
          .date()
          .nullable()
          .typeError('Data non valida')
          .required('Campo obbligatorio'),
      }),
      isForeignDocument: yup.string(),
      municipalityDocument: yup
        .object()
        .nullable()
        .when('isForeignDocument', {
          is: DocumentRadioCertificate.IdentityCard,
          otherwise: yup.object().nullable().notRequired(),
          then: yup.object().required('Campo obbligatorio'),
        }),
    }),
    otherwise: yup.object().shape({}),
  }),
  accountholder: yup
    .object()
    .shape({})
    .test('accountHolder', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as AccordionAccountholderFormVM;

      // same as applicant
      if (valuesCasted?.sameApplicant) {
        return true;
      }

      // fiscal code required
      if (!valuesCasted?.account?.applicant?.fiscalCode) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'accountholder.account.applicant.fiscalCode'
        );
      }

      // search required
      if (!valuesCasted?.searchAccountholder) {
        return new yup.ValidationError(
          'Effettuare ricerca',
          undefined,
          'accountholder.searchAccountholder'
        );
      }

      return true;
    }),
};
